import axios from 'services/local/api';

// endpoint
import { getUsersEp } from 'services/local/endpoints';

const getUsers = async () => await axios.get(getUsersEp);

export default getUsers;
